'use client'

import Link from 'next/link'
import Image from 'next/image'
import dynamic from 'next/dynamic'
import { Icons } from '@/components/icons'
import {
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Text,
  Box,
} from '@chakra-ui/react'
import { useRouter, useSearchParams } from 'next/navigation'

const UserAuthForm = dynamic(
  () => import('@/components/auth-page/user-auth-form'),
  { loading: () => null }
)

const BusinessAuthForm = dynamic(
  () => import('@/components/auth-page/business-auth-form'),
  { loading: () => null }
)

const SrcTracking = dynamic(
  () => import('@/src/app/(landing-page)/src-tracking'),
  { ssr: false, loading: () => null }
)

export default function AuthenticationPage() {
  const router = useRouter()

  const searchParams = useSearchParams()

  return (
    <>
      {/* <AuthenticationCheck /> */}
      {/* <Analytics eventType='login'/> */}
      <SrcTracking />
      <Box className="h-full w-full xs:mt-4 lg:mt-0 lg:p-8">
        <Box className="hidden lg:block">
          <Box
            display={'flex'}
            alignItems="center"
            pb={2}
            gap={1}
            w={'fit-content'}
            cursor={'pointer'}
            onClick={() => router.push('/home')}
          >
            <Icons.chevronLeft className="h-4 w-4" />
            <Text
              as={'h3'}
              fontSize={{ base: 'sm', md: 'sm' }}
              _hover={{ textDecoration: 'underline' }}
            >
              Home
            </Text>
          </Box>
        </Box>
        <Box
          mt={2}
          className="relative mx-auto flex items-center justify-center  text-lg font-semibold lg:hidden"
          href="/home"
          as={Link}
        >
          <Image
            src={`/lykstage-logo.svg`}
            alt="logo"
            className="relative h-auto font-semibold"
            width={180}
            height={40}
          />
        </Box>
        <Box
          alignItems="center"
          className="mx-auto mt-6 w-full max-w-lg px-5 md:mt-6 md:w-[60%] md:max-w-2xl md:px-0 lg:mt-10 lg:w-[90%] xl:w-[85%]"
        >
          <Text
            className="text-center text-2xl font-bold lg:text-left lg:text-2xl"
            color={'lyk-black'}
          >
            Welcome back!
          </Text>
          <Tabs
            isLazy
            lazyBehavior="keepMounted"
            defaultIndex={
              searchParams?.get('user')
                ? searchParams?.get('user') == 'normal'
                  ? 0
                  : 1
                : 0
            }
            onChange={(index) => {
              router.push(
                `/auth/login?user=${index == 0 ? 'normal' : 'business'}`
              )
            }}
          >
            <TabList
              // ml={{ base: '4', md: '16', lg: '24' }}
              mt={{ base: '2', md: '4' }}
              className="rounded-full p-[2px] pb-[4px]"
              maxW={{ base: '200px', md: '280px', lg: '330px' }}
              border={'1px solid #E5E5E5'}
              display="flex"
              justifyContent={{
                base: 'center',
                md: 'center',
                lg: 'flex-start',
              }}
              mx={{ base: 'auto', md: 'auto', lg: '0' }}
            >
              <Tab
                _selected={{ color: 'white', bg: 'lyk-green' }}
                className="rounded-full py-0 md:px-6 lg:px-8"
                fontWeight={'500'}
                flex="1"
                fontSize={{
                  base: 'sm',
                  md: 'md',
                }}
              >
                <Text>Individual</Text>
              </Tab>
              <Tab
                _selected={{ color: 'white', bg: 'lyk-green' }}
                className="rounded-full py-0 md:px-6 lg:px-8"
                fontWeight={'500'}
                flex="1"
                fontSize={{
                  base: 'sm',
                  md: 'md',
                }}
              >
                <Text>Business</Text>
              </Tab>
            </TabList>
            <TabPanels>
              <TabPanel p={0} mt={5}>
                <UserAuthForm
                  formType={'login'}
                />
              </TabPanel>
              <TabPanel p={0} mt={5}>
                <BusinessAuthForm
                  formType="login"
                />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Box>
      </Box>
    </>
  )
}
